export default __webpack_public_path__ + "static/amanda-tucker-e373127569545267e1421df0d867ce06.png";